module.exports = __webpack_public_path__ + "static/media/traction_disabled.e0ea688b.svg";